// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__TUUkX","list":"styles_list__MGH4i"};